import React from 'react';
import { clients } from '../mock';

const ClientsMarquee = () => {
  // Duplicate clients twice for seamless looping
  const duplicatedClients = [...clients, ...clients];

  return (
    <div className="relative w-full overflow-hidden py-4">
      {/* Gradient overlays for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>
      
      <div className="flex marquee-track">
        {duplicatedClients.map((client, index) => (
          <div
            key={index}
            className="flex-shrink-0 mx-6"
          >
            <div className="bg-white border-2 border-slate-200 rounded-lg shadow-md hover:shadow-xl hover:border-red-400 transition-all duration-300 p-4 w-56 h-44 flex flex-col items-center justify-center group">
              {client.logo ? (
                <div className="w-full h-28 flex items-center justify-center mb-2">
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
              ) : (
                <div className="w-full h-28 flex items-center justify-center mb-2">
                  <div className="w-16 h-16 bg-gradient-to-br from-red-100 to-orange-100 rounded-full flex items-center justify-center">
                    <span className="text-2xl font-bold text-red-600">
                      {client.name.split(' ').map(w => w[0]).slice(0, 2).join('')}
                    </span>
                  </div>
                </div>
              )}
              <p className="text-center text-xs font-semibold text-slate-800 line-clamp-2">
                {client.name}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientsMarquee;
